import { TextField } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

const SelectCategories = ({
  name,
  label,
  control,
  rules,
  optionList,
  disabled,
  ...rest
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules[name]}
      render={({
        field: { value = { categories_ids: [], new_categories: [] }, onChange },
        fieldState: { error },
      }) => {
        const displayValue = [
          ...optionList.filter((opt) => {
            return value.categories_ids.includes(opt.id);
          }),
          ...value.new_categories.map((c) => ({ category_name: c })),
        ];

        return (
          <Autocomplete
            size="medium"
            multiple
            freeSolo
            value={displayValue}
            options={!disabled ? optionList : []}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.category_name || ""
            }
            filterSelectedOptions
            onChange={(e, newVal) => {
              if (disabled) return;

              const categories_ids = [];
              const new_categories = [];

              newVal.forEach((item) => {
                if (typeof item === "string") {
                  new_categories.push(item);
                } else if (item?.id) {
                  categories_ids.push(item.id);
                } else if (item?.category_name && !item.id) {
                  new_categories.push(item.category_name);
                }
              });

              onChange({ categories_ids, new_categories });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={Boolean(error)}
                helperText={error ? error.message : ""}
                size="medium"
                variant="outlined"
                label={label}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === ",") {
                    event.preventDefault();
                    const inputValue = event.target.value.trim();
                    if (inputValue) {
                      onChange({
                        categories_ids: value.categories_ids,
                        new_categories: [...value.new_categories, inputValue],
                      });
                    }
                  }
                }}
              />
            )}
            disabled={disabled}
            {...rest}
          />
        );
      }}
    />
  );
};

export default SelectCategories;
